/**
 * @generated SignedSource<<833ee67b07d1e2fa9ffc5f15e94f6ccd>>
 * @lightSyntaxTransform
 * @nogrep
 */

/* eslint-disable */

'use strict';

var node = {
  "argumentDefinitions": [],
  "kind": "Fragment",
  "metadata": {
    "throwOnFieldError": true
  },
  "name": "TradeRuleShow_rule",
  "selections": [
    {
      "alias": null,
      "args": null,
      "kind": "ScalarField",
      "name": "uuid",
      "storageKey": null
    },
    {
      "args": null,
      "kind": "FragmentSpread",
      "name": "TradeRuleTimeline_rule"
    }
  ],
  "type": "TradeRule",
  "abstractKey": null
};

node.hash = "db35dcdd653eed005286f45cfeeb8aef";

export default node;
